import { dashboardPath } from 'components/Routes'

import { Grid2, Typography } from '@mui/material'
import Button from 'components/Button'
import DefaultLayout from 'components/layout/DefaultLayout'
import { useNavigate } from 'react-router-dom'

export default function VerificationPartialSuccess(): JSX.Element {
  const navigate = useNavigate()

  return (
    <DefaultLayout
      backgroundColor='white'
      heading='Partial verification success'
    >
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12 }}>
          <Typography variant='body1'>
            Woops we had a little trouble verifying your identity, we'll be in
            touch to sort it out but in the mean time you can start digging for
            gold.
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12 }}>
          <Button
            color='primary'
            fullWidth
            onClick={() => navigate(dashboardPath())}
          >
            Go to your Dashboard
          </Button>
        </Grid2>
      </Grid2>
    </DefaultLayout>
  )
}
